"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : NAV : BUBBLE : STYLES --------------- ++++++++++ */


var _default = {
  bubblenav: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'flex-start',
    '& .link': {
      borderRadius: (0, _index.pxToEm)(22),
      color: _index.theme.color.supporting.dark.swatch,
      fontSize: (0, _index.pxToEm)(14),
      padding: (0, _index.replacePXinStringWithEM)("10px 20px"),
      marginRight: (0, _index.pxToEm)(10),
      '&:hover': {
        // background: convertHexToRGB(theme.color.secondary.medium.swatch, 10)
        background: (0, _index.convertHexToRGB)('#F3F5F8', 20)
      },
      '&.isActive-true': {
        background: (0, _index.convertHexToRGB)(_index.theme.color.primary.medium.swatch, 10),
        color: _index.theme.color.primary.medium.swatch
      }
    }
  }
};
exports.default = _default;